let assert = () => {}

if (process.env.REACT_APP_ENVIROMENT !== "production") {
  assert = (...args) => console.assert(...args)
}

/** @type {(fn: () => void) => void} fn */
let dbg = () => {}

if (process.env.REACT_APP_ENVIROMENT !== "production") {
  dbg = (fn) => fn()
}

module.exports = { assert, dbg }
